import { CardBody, Col, Row } from "reactstrap";
import { H5, H6 } from "../../../AbstractElements";
import { FLAG_ICONS } from "../../../Data/Icons";
import { FlagIconType, GetItagProp } from "../../../Type/Icons";

export const FlagIconCardBody = ({ setiTag, setIcon }: FlagIconType) => {
  const getItag = (tag: GetItagProp) => {
    setiTag({
      iTag: '<i className="fi fi-' + tag.abbrivation + '"></i>',
    });
    setIcon({
      icon: "fi fi-" + tag.abbrivation + " fa-2x",
    });
  };
  
  return (
    <CardBody>
      <Row className="icon-lists flag-icons">
        {FLAG_ICONS.map((icon, index) => (
          <Col sm="6" xl="4" key={index} onClick={() => getItag(icon)}>
            <div className="d-flex">
              <i className={`flag-icon flag-icon-${icon.abbrivation}`}></i>
              <div className="flex-grow-1 align-self-center">
                <H5 className="text-uppercase">{icon.abbrivation}</H5>
                <H6 className="mt-0">{icon.name}</H6>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </CardBody>
  );
};
